import { GTMPageType } from 'modules/gtm/constants';
import { push } from 'modules/gtm/modules/common';
import { ScrollDataType } from 'modules/gtm/modules/types';

export const gtmPushScrollManually = ({
  pageType,
  currentPage,
}: ScrollDataType) => {
  push({
    event: 'Generic Event',
    event_name: 'scroll_manually',
    scroll_manually: {
      event_category: 'scroll',
      event_action: pageType && GTMPageType[pageType], // e.g. 'home'
      page_location: pageType && GTMPageType[pageType],
      event_label: `${currentPage} - manually`, // e.g '1 - manually'
    },
  });
};

export const gtmPushScrollAutomatically = ({
  pageType,
  currentPage,
}: ScrollDataType) => {
  push({
    event: 'Generic Event',
    event_name: 'scroll_automatically',
    scroll_automatically: {
      event_category: 'scroll',
      event_action: pageType && GTMPageType[pageType], // e.g. 'home'
      page_location: pageType && GTMPageType[pageType],
      event_label: `${currentPage} - automatically`, //e.g. '1 - automatically'
    },
  });
};
